// PROJECTS
import pomidoro from 'Assets/Images/projects/pomidoro.png'
import moneymix from 'Assets/Images/projects/moneymix.png'
import crypto from 'Assets/Images/projects/crypto.png'
import safephone from 'Assets/Images/projects/safephone.png'
import maritel from 'Assets/Images/projects/maritel.png'
import fashionfy from 'Assets/Images/projects/fashionfy.png'
import designly from 'Assets/Images/projects/designly.png'
import learningworld from 'Assets/Images/projects/learningworld.png'
import portfolio from 'Assets/Images/projects/portfolio.jpg'

// TECHNOLOGIES
import JavaScript from 'Assets/Images/Icons/technologies/js.png'
import TypeScript from 'Assets/Images/Icons/technologies/typescript.svg'

import React from 'Assets/Images/Icons/technologies/react.svg'
import Gatsby from 'Assets/Images/Icons/technologies/gatsby.svg'
import Redux from 'Assets/Images/Icons/technologies/redux.svg'
import HTML5 from 'Assets/Images/Icons/technologies/html5.svg'
import CSS3 from 'Assets/Images/Icons/technologies/css3.svg'
import SCSS from 'Assets/Images/Icons/technologies/scss.svg'
import JestTDD from 'Assets/Images/Icons/technologies/tdd-jest.svg'

import NodeJS from 'Assets/Images/Icons/technologies/nodejs.svg'
import Firebase from 'Assets/Images/Icons/technologies/firebase.svg'
import Python from 'Assets/Images/Icons/technologies/python.svg'

import Swift from 'Assets/Images/Icons/technologies/swift.svg'
import UIKit from 'Assets/Images/Icons/technologies/uikit.png'

import Git from 'Assets/Images/Icons/technologies/git.svg'
import NPM from 'Assets/Images/Icons/technologies/npm.svg'
import GitHub from 'Assets/Images/Icons/technologies/github.svg'

const images = {
  pomidoro,
  moneymix,
  crypto,
  safephone,
  maritel,
  fashionfy,
  designly,
  learningworld,
  portfolio,
} as any

export const useProjectImage = (title: string) => {
  const value = title.replace(/\s/g, '').toLowerCase()
  return images[value]
}

const Techs = {
  JavaScript,
  TypeScript,
  React,
  Gatsby,
  HTML5,
  CSS3,
  SCSS,
  'React Native': React,
  'Jest TDD': JestTDD,
  'Node JS': NodeJS,
  Redux,
  Firebase,
  Python,
  Swift,
  UIKit,
  'Swift UI': Swift,
  //
  NPM,
  Git,
  GitHub,
} as any

export const renderTechnologyImage = (tech: string) => {
  return Techs[tech]
}
